import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface RemainingTimeInputProps {
  formClassName: string;
  name: string;
  translationRoot: string;
}

export const RemainingTimeInput = ({
  name,
  formClassName,
  translationRoot,
}: RemainingTimeInputProps) => (
  <Form.Item
    className={formClassName}
    name={name}
    translationRoot={translationRoot}
    hideLabel
    hidePlaceholder
    hideBorder
    hideDescription
    rules={{
      max: {
        value: 60,
        message: t([translationRoot, "errors.remaining_time_threshold"]),
      },
      min: {
        value: 1,
        message: t([translationRoot, "errors.remaining_time_threshold"]),
      },
    }}
    variant="extra-bottom-margin"
  >
    <Form.Input
      data-testid="countdown-remaining_time-input"
      type="number"
      min={1}
      max={60}
      suffix={
        <Typography.BodyMd>
          {t([translationRoot, "remaining_time_suffix"])}
        </Typography.BodyMd>
      }
    />
  </Form.Item>
);
